import React from 'react';
import type { Tone } from '../../utils/caseStatus';
const TONES: Record<Tone, string> = {
  navy: 'bg-navy-50 text-navy border-navy-100',
  green: 'bg-success-50 text-success border-success/20',
  warning: 'bg-warning-50 text-warning-700 border-warning/30',
  danger: 'bg-danger-50 text-danger-700 border-danger/25',
  gray: 'bg-slate-100 text-ink-muted border-slate-200',
  sky: 'bg-sky text-navy-600 border-navy-100'
};
export function StatusBadge({
  label,
  tone,
  size = 'md'
}: {
  label: string;
  tone: Tone;
  size?: 'sm' | 'md';
}) {
  return <span className={`inline-flex items-center gap-1.5 rounded-full border font-semibold whitespace-nowrap ${TONES[tone]} ${size === 'sm' ? 'px-2 py-0.5 text-[11px]' : 'px-2.5 py-0.5 text-xs'}`} data-id="element-393" data-mp="k7vlfogbwm3i">
      <span className="h-1.5 w-1.5 rounded-full bg-current" aria-hidden data-id="element-394" data-mp="ah0ui6s50ybq" />
      {label}
    </span>;
}